

















































































































import { Vue, Component } from 'vue-property-decorator';
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { SublimeCompanyType } from "@/dto/SublimeCompanyType";
import SelectOption from "@/components/common/SelectOption";
import PaymentsService from "@/services/PaymentsService";
import { processError } from "@/utils/ComponentUtils";
import { namespace } from "vuex-class";
import SendSublimeInvoicePayload from "@/dto/payment/invoice/SendSublimeInvoicePayload";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import { WorkspaceType } from "@/dto/auth/Workspace";

const AppModule = namespace("App");

@Component({
  components: { SingleFileHolder, PortalInput, PortalSelect, PortalDate, SimpleProfileSearch }
})
export default class SendInvoiceModal extends Vue {
  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  payload = new SendSublimeInvoicePayload();

  selectedProfile: ProfileDTO | null = null;

  get payerTypeOptions() {
    return Object.values(CounterpartyType).map(type => 
      SelectOption.builder().title(type).value(type).build()
    );
  }

  get sublimeCompanyOptions() {
    return Object.values(SublimeCompanyType).map(type => 
      SelectOption.builder().title(this.formatString(type)).value(type).build()
    );
  }

  get isFormValid() {
    return this.payload.document && 
           this.payload.payerId && 
           this.payload.payerType && 
           this.payload.sublimeCompany && 
           this.payload.invoiceNumber && 
           this.payload.invoiceDate && 
           this.payload.dueDate && 
           this.payload.amount && 
           this.payload.reference && 
           this.payload.paymentLink;
  }

  formatString(str: string): string {
    return str.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  onProfileSelected(profile: ProfileDTO) {
    if (profile) {
      this.payload.payerId = profile.id;

      // Map WorkspaceType to CounterpartyType
      if (profile.type === WorkspaceType.PERSON) {
        this.payload.payerType = CounterpartyType.PERSON;
      } else if (profile.type === WorkspaceType.COMPANY) {
        this.payload.payerType = CounterpartyType.COMPANY;
      }
    } else {
      this.payload.payerId = null;
    }
  }

  sendInvoice() {
    if (!this.isFormValid) return;

    this.startLoading();
    PaymentsService.sendSublimeInvoice(this.payload)
      .then(() => {
        this.$emit('close');
        this.$notify({
          group: 'portal',
          type: 'success',
          title: 'Success',
          text: 'Invoice sent successfully'
        });
        this.stopLoading();
      })
      .catch(err => {
        processError(err, this);
        this.stopLoading();
      });
  }
}
